import { render, staticRenderFns } from "./ProductRecommendations.vue?vue&type=template&id=325bc555&scoped=true&lang=pug&"
import script from "./ProductRecommendations.vue?vue&type=script&lang=js&"
export * from "./ProductRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecommendations.vue?vue&type=style&index=0&id=325bc555&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325bc555",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('325bc555')) {
      api.createRecord('325bc555', component.options)
    } else {
      api.reload('325bc555', component.options)
    }
    module.hot.accept("./ProductRecommendations.vue?vue&type=template&id=325bc555&scoped=true&lang=pug&", function () {
      api.rerender('325bc555', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductRecommendations.vue"
export default component.exports